import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useActiveContextReady } from './useActiveContextReady';
import { config } from '../config';

export interface OperationResult {
  operationName: string;
  status: string;
  protocolUsed: string;
  output: string;
  error: string;
}

export interface ConfigChangeResultDetail {
  overallResult: string;
  operationResults: OperationResult[];
  preSnapshotId: string | null;
  postSnapshotId: string | null;
  auditId: string;
}

export interface ConfigChange {
  id: string;
  deviceId: string;
  status: string;
  result: ConfigChangeResultDetail | null;
  createdAt: string;
  completedAt: string | null;
}

interface ConfigChangeListResponse {
  configChanges: ConfigChange[];
}

export function useConfigChanges(deviceId: string | undefined) {
  const contextReady = useActiveContextReady();
  return useQuery<ConfigChange[]>({
    queryKey: ['configChanges', deviceId],
    queryFn: async () => {
      if (!deviceId) throw new Error('Device ID is required');
      const response = await axios.get<ConfigChangeListResponse>(
        `${config.backendApi}/api/devices/${deviceId}/config-changes`,
        { withCredentials: true }
      );
      return response.data.configChanges;
    },
    enabled: !!deviceId && contextReady,
  });
}
